import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCookiecutterComponent } from './simple-icons-cookiecutter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCookiecutterComponent ],
    exports:      [ SimpleIconsCookiecutterComponent ],
    bootstrap:    []
})
export class SimpleIconsCookiecutterModule {}
